import React, { useMemo } from 'react'

import { AppearingWrapper, SectionContainer } from 'Components/Blocks'
import { SubsectionTitle } from 'Components/Blocks/Titles'

import {
  LANDING_CONTENT_PX,
  LANDING_SECTION_GAP,
  LANDING_SECTION_PY,
} from 'Constants/Landing'
import { LANDING_DISPLAYED_TESTIMONIAL_IDS } from 'Constants/Testimonials'

import { TestimonialRecordFieldsFragment } from 'GraphQL/DatoCMS/TypedDocuments'

import Gallery from './Gallery'
import { Container } from './styles'

type Props = {
  data?: TestimonialRecordFieldsFragment[]
}

function MeetOutMembersSection({ data }: Props) {
  const dataItemsToShow = useMemo(() => {
    if (!data) return []

    return data
      .filter(item => LANDING_DISPLAYED_TESTIMONIAL_IDS.has(item.id))
      .filter((item): item is TestimonialRecordFieldsFragment => !!item)
  }, [data])

  if (!dataItemsToShow) return null

  return (
    <SectionContainer>
      <AppearingWrapper centered>
        <Container
          gap={LANDING_SECTION_GAP}
          px={LANDING_CONTENT_PX}
          py={LANDING_SECTION_PY}
        >
          <SubsectionTitle
            centered
            subtitle="Don’t take our word for it, hear directly from our members"
            title="Meet Our Members"
          />

          <Gallery data={dataItemsToShow} />
        </Container>
      </AppearingWrapper>
    </SectionContainer>
  )
}

export default MeetOutMembersSection
